export default {"src":"/_next/static/media/arr.3c5206d8.svg","height":25,"width":30,"blurWidth":0,"blurHeight":0};